import React, { useState, Component } from 'react';
import { SendIcon, PaperclipIcon, Image as ImageIcon } from 'lucide-react';
export const MailApp: React.FC = () => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const handleSend = () => {
    const mailtoLink = `mailto:emmanuelsaka333@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink, '_blank');
  };
  return <div className="h-full w-full bg-[#f5f5f7] dark:bg-[#1e1e1e] flex flex-col text-gray-900 dark:text-gray-100" data-id="element-40" data-mp="2b2y3o05l5e2n">
      {/* Toolbar */}
      <div className="h-14 border-b border-gray-300 dark:border-white/10 flex items-center px-4 justify-between bg-white/50 dark:bg-white/5 backdrop-blur-md" data-id="element-41" data-mp="2kzko4nu02345">
        <button onClick={handleSend} className="flex items-center gap-2 px-3 py-1.5 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-sm font-medium transition-colors" data-id="element-42" data-mp="2q08mxvogzo8x">
          <SendIcon size={16} data-id="element-43" data-mp="56lokvxa18vt" /> Send
        </button>
        <div className="flex items-center gap-4 text-gray-500 dark:text-gray-400" data-id="element-44" data-mp="11p86i1m1sujy">
          <button className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors" data-id="element-45" data-mp="wpvaaq9aeb4p">
            <PaperclipIcon size={18} data-id="element-46" data-mp="so0cvwuh8hw7" />
          </button>
          <button className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors" data-id="element-47" data-mp="smgthxdixqq7">
            <ImageIcon size={18} data-id="element-48" data-mp="nof9na89xndo" />
          </button>
        </div>
      </div>

      {/* Headers */}
      <div className="px-6 py-2 border-b border-gray-300 dark:border-white/10 space-y-2 bg-white dark:bg-[#1e1e1e]" data-id="element-49" data-mp="irf4d1j90onm">
        <div className="flex items-center text-sm" data-id="element-50" data-mp="dx13ijlthpbk">
          <span className="w-16 text-gray-500 dark:text-gray-400" data-id="element-51" data-mp="8z9fw1s7gpd6">To:</span>
          <span className="px-2 py-0.5 bg-blue-100 dark:bg-blue-500/20 text-blue-700 dark:text-blue-400 rounded-md" data-id="element-52" data-mp="4ypg0qg8z7nc">
            Emmanuel Saka &lt;emmanuelsaka333@gmail.com&gt;
          </span>
        </div>
        <div className="flex items-center text-sm border-t border-gray-100 dark:border-white/5 pt-2" data-id="element-53" data-mp="3r54786pvpmr7">
          <span className="w-16 text-gray-500 dark:text-gray-400" data-id="element-54" data-mp="3hhiepuv63pvf">
            Subject:
          </span>
          <input type="text" value={subject} onChange={e => setSubject(e.target.value)} placeholder="What's this about?" className="flex-1 bg-transparent outline-none border-none placeholder-gray-400" data-id="element-55" data-mp="3mhel20rc7te5" />
        </div>
      </div>

      {/* Body */}
      <div className="flex-1 p-6 bg-white dark:bg-[#1e1e1e]" data-id="element-56" data-mp="44gehb01i2b0">
        <textarea value={body} onChange={e => setBody(e.target.value)} placeholder="Write your message here..." className="w-full h-full bg-transparent outline-none border-none resize-none font-sans text-sm leading-relaxed placeholder-gray-400" data-id="element-57" data-mp="91ypd6xmarln" />
      </div>
    </div>;
};